<template>
  <md-field :class="[
                {'md-error': errors.has('shopId')},
                {'md-valid': !errors.has('shopId') && touched.shopId}]" >
    <md-select v-model="shopId"  
      data-vv-name="shopId"
      v-validate= "avoidValidFlag == true ? '' : modelValidations.shopId" multiple v-if="mutlipleFlag">
            <md-option v-for="item in listData" :value="item.id" :key="item.id">{{item.name}}</md-option>
    </md-select>
    <md-select
      v-model="shopId"
      data-vv-name="shopId"
      v-validate= "avoidValidFlag == true ? '' : modelValidations.shopId" v-if="!mutlipleFlag">
      <md-option v-for="item in listData" :value="item.id" :key="item.id">{{item.name}}</md-option>
    </md-select>
    <slide-y-up-transition>
      <div class="vErrorText" v-show="errors.has('shopId')">【必須】必ず一つ選択してください</div>
    </slide-y-up-transition>
    <slide-y-down-transition>
      <md-icon class="error" v-show="errors.has('shopId')" style="margin-right:20px">close</md-icon>
    </slide-y-down-transition>
    <slide-y-down-transition>
      <md-icon class="success" v-show="!errors.has('shopId') && touched.shopId" style="margin-right:20px">done</md-icon>
    </slide-y-down-transition>
  </md-field>
</template>
<script>
  import NestedValidator from '../../mixins/nested-validator'
  export default {
    inject: ['$validator'],
    mixins: [NestedValidator],
    data() {
      return {
        listData: [],
        modelValidations: {
          shopId: {
            required: true
          }
        },
        touched: {
          shopId: false,
        },
      }
    },
    model: {
    },
    props:  ['value','noSelectFlag','saveCondition','touchedFlag', 'avoidValidFlag', 'mutlipleFlag'],    // undefinedはfalse扱い
    methods: {
      getShops () {
        var condition = {
          company_id: (this.companyId==='選択しない' || this.companyId==null) ? '' : this.companyId,
          brand_id: (this.brandId==='選択しない' || this.brandId==null) ? '' : this.brandId,
        }
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/shops/select_list',
          timeout : 10000,
          params: condition,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.createList(response.data)
          sessionStorage.setItem('shopSelect', JSON.stringify(response.data))
        })
        .catch(error => {
          this.dangerNotify('店舗リストを取得できませんでした')
        })
      },
      createList (obj) {
        this.listData = []
        if (this.noSelectFlag) {
          var item = {
            id: '選択しない',
            name: '選択しない',
          }
          this.listData.push(item)
          if (!this.saveCondition) {
            this.companyId = '選択しない'
          }
        }
        for (var i in obj) {
          var item = {
            id: obj[i].id,
            name: obj[i].name
          }
          this.listData.push(item)
        }
      },
      setShop () {
        var shopSelect = sessionStorage.getItem('shopSelect')
        if (shopSelect === null) {
          this.getShops()
        } else {
          shopSelect = JSON.parse(shopSelect)
          this.createList(shopSelect)
        }
      },
      resetShop () {
        sessionStorage.removeItem('shopSelect')
        this.setShop()
      }
    },
    mounted () {
      this.setShop()
      this.touched.shopId = false
    },watch: {
      shopId(){
        this.touched.shopId = this.touchedFlag
      },
      '$route.path'(value){
        if (value.match('new')) {
          this.$validator.reset()
          this.touched.shopId = false 
        }
      }
    },computed: {
      shopId: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue)
        }
      }
    }

  }
</script>
<style scoped>
.shopSelect{
  /* max-width: 120px; */
  width: 100%;
}
</style>